module.exports = __webpack_public_path__ + "img/fossil2Img1.e7c2195d.jpg";